import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { saveStateToLocalStorage } from './actions/defaultActions';
import { connectWebsocket, siteboardAction, redeemLoginCode, } from './actions/defaultActions';
import { getJsonFromUrl, getServerApiResponse, debugLog, uuidv4, } from './Util.js';
import { 
  LoginCode, Email, UserName, SET_USING_INVITE_LINK, CHECK_LOGIN_CODE, CHECK_STANDARD_SIGNUP_CODE, CHECK_TRIAL_SIGNUP_CODE, LOG_POSTCARD1_PROMO_LINK_VISITED,
  SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK, User, Subscription, Schedule, Project, Activity, SETUP_LOCAL_SESSION,
  ShareScheduleCode, SET_USING_SHARE_SCHEDULE_LINK, CHECK_PROMO_SIGNUP_CODE, SET_USING_PROMO_SIGNUP_LINK,
} from './actions/types';
import { format } from 'date-fns';
//import './actions/types.test.js';

// save redux state to local storage when it changes
store.subscribe(() => {
  saveStateToLocalStorage(store.getState()); // TODO: only do this when localStorage changes
});

// Check URL for special links
const urlParams = getJsonFromUrl(window.location.search.substring(1));
if(urlParams['promo'] === 'postcard1') { // promo code from postcard, https://app.siteboard.construction/?promo=postcard1
  getServerApiResponse({
    action: LOG_POSTCARD1_PROMO_LINK_VISITED,
  }, ()=>{}, ()=>{});
  window.history.pushState('', '', '?'); // clear the url
}
if(LoginCode.isValid(urlParams['invite_code']) && Email.isValid(urlParams['email'])) {
  // invite code
  store.dispatch(siteboardAction(SET_USING_INVITE_LINK, { inviteCode: urlParams['invite_code'], inviteEmail: urlParams['email'], }));
} else if(LoginCode.isValid(urlParams['invite_schedule_updates_code']) && Email.isValid(urlParams['email'])) {
  // schedule updates invite code 
  store.dispatch(siteboardAction(SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, { inviteCode: urlParams['invite_schedule_updates_code'], inviteEmail: urlParams['email'], }));
} else if(LoginCode.isValid(urlParams['unsubscribe_schedule_updates_code']) && Email.isValid(urlParams['email'])) {
  // schedule updates unsubscribe code 
  store.dispatch(siteboardAction(SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK, { unsubscribeCode: urlParams['unsubscribe_schedule_updates_code'], unsubscribeEmail: urlParams['email'], }));
} else if(LoginCode.isValid(urlParams['trial_signup_code']) && Email.isValid(urlParams['email']) && UserName.isValid(urlParams['firstName']) && UserName.isValid(urlParams['lastName'])) {
  // trial signup code
  store.dispatch(redeemLoginCode({
    action: CHECK_TRIAL_SIGNUP_CODE,
    email: urlParams['email'],
    loginCode: urlParams['trial_signup_code'],
    firstName: urlParams['firstName'],
    lastName: urlParams['lastName'],
    loadingMessage: 'Finalizing Account Setup',
    defaultErrorMessage: 'There was an error with your signup link',
  }, true)); 
} else if(LoginCode.isValid(urlParams['standard_signup_code']) && Email.isValid(urlParams['email']) && UserName.isValid(urlParams['firstName']) && UserName.isValid(urlParams['lastName'])) {
  // standard signup code
  store.dispatch(redeemLoginCode({
    action: CHECK_STANDARD_SIGNUP_CODE,
    email: urlParams['email'],
    loginCode: urlParams['standard_signup_code'],
    firstName: urlParams['firstName'],
    lastName: urlParams['lastName'],
    loadingMessage: 'Continuing Account Setup',
    defaultErrorMessage: 'There was an error with your signup link',
  }, true)); 
} else if(LoginCode.isValid(urlParams['promo_signup_code']) && Email.isValid(urlParams['email']) && UserName.isValid(urlParams['firstName']) && UserName.isValid(urlParams['lastName']) && ShareScheduleCode.isValid(urlParams['promoCode'])) {
  // promo signup code
  store.dispatch(redeemLoginCode({
    action: CHECK_PROMO_SIGNUP_CODE,
    email: urlParams['email'],
    loginCode: urlParams['promo_signup_code'],
    firstName: urlParams['firstName'],
    lastName: urlParams['lastName'],
    promoCode: urlParams['promoCode'],
    loadingMessage: 'Continuing Account Setup',
    defaultErrorMessage: 'There was an error with your signup link',
  }, true)); 
} else if(ShareScheduleCode.isValid(urlParams['promoCode'])) {
  store.dispatch(siteboardAction(SET_USING_PROMO_SIGNUP_LINK, { promoCode: urlParams['promoCode'] }));
} else if(LoginCode.isValid(urlParams['login_code']) && Email.isValid(urlParams['email'])) {
  // login code
  store.dispatch(redeemLoginCode({
    action: CHECK_LOGIN_CODE,
    email: urlParams['email'],
    loginCode: urlParams['login_code'],
    loadingMessage: 'Logging you in',
    defaultErrorMessage: 'There was an error logging you in',
  }, true)); 
} else if(ShareScheduleCode.isValid(urlParams['share_schedule_code'])) {
  store.dispatch(siteboardAction(SET_USING_SHARE_SCHEDULE_LINK, { shareCode: urlParams['share_schedule_code'] }));
} else if(window.location.pathname === '/freeScheduleTool') {
  const currentTimestamp = new Date().getTime();
  const projectId = uuidv4();
  const subscriptionId = uuidv4();
  const user = User.validate({
    id: uuidv4(),
    email: 'trial@test',
    firstName: 'trial',
    lastName: 'test',
    projects: {[projectId]: ''},
    isOnline: true,
    lastOnlineTimestamp: currentTimestamp,
    ownedSubscriptionId: subscriptionId,
    subscriptions: {[subscriptionId]: ''},
  });
  const subscription = Subscription.validate({
    id: subscriptionId,
    type: 'Trial',
    members: {[user.id]: {
      role: 'Owner',
      modifiedTimestamp: currentTimestamp,
      createdTimestamp: currentTimestamp,
    }},
    projectIds: {[projectId]: ''},
    userCount: 1,
    projectCount: 1,
    scheduleCount: 1,
    contactCount: 0,
    endTimestamp: currentTimestamp,
    createdTimestamp: currentTimestamp,
    modifiedTimestamp: currentTimestamp,
  });
  const schedule = Schedule.validate({
    id: uuidv4(),
    projectId: projectId,
    beginDate: format(new Date().getTime(), 'MM/dd/yyyy'),
  });
  const project = Project.validate({
    id: projectId,
    ownerId: user.id,
    subscriptionId: subscription.id,
    name: 'Untitled Project',
    members: {[user.id]: {
      role: 'Owner',
      modifiedTimestamp: currentTimestamp,
      createdTimestamp: currentTimestamp,
    }},
    schedules: {[schedule.id]: schedule.beginDate},
    createdTimestamp: currentTimestamp,
    modifiedTimestamp: currentTimestamp,
  });
  const activity = Activity.validate({
    id: uuidv4(),
    scheduleId: schedule.id,
    projectId: project.id,
  });

  store.dispatch(siteboardAction(SETUP_LOCAL_SESSION, {
    userId: user.id,
    users: [user],
    activities: [activity],
    projects: [project],
    schedules: [schedule],
    subscriptions: [subscription],
    userPreferences: {
      userId: user.id,
      darkMode: true,
    },
  }));
}

if (store.getState().localPersistent.isLoggedIn === true 
  && store.getState().serverSynced.localOnlyMode !== true 
  && store.getState().localEphemeral.isUsingShareScheduleLink !== true) {

  store.dispatch(connectWebsocket());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//import reportWebVitals from './reportWebVitals';
//reportWebVitals();
